<template>
  <div class="placeholder-scene">
    <i class="el-icon-document"></i>
    <p>该章节内容待配置</p>
  </div>
</template>

<script>
export default {
  name: 'JstErpPlaceholderScene'
}
</script>

<style scoped>
.placeholder-scene { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 520px; color: #a0a8b8; background: #fff; }
.placeholder-scene i { margin-bottom: 14px; font-size: 42px; color: #bfd0ed; }
.placeholder-scene p { margin: 0; font-size: 15px; }
</style>



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/JstErpPlaceholderScene.vue